import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { uploadImage } from '../../features/deeplink/api';
import styles from './style.module.css';
import { addBanner } from '../../features/cmscountry/api';

interface Props {
  show: boolean;
  handleClose: () => void;
  getFaqs: () => void;
  countryId: string;
}

const CreateUpdateBanner = ({ show, handleClose, getFaqs, countryId }: Props) => {
  const [isUploading, setIsUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [altText, setAltText] = useState('');

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setIsUploading(true);
      const formData = new FormData();
      formData.append('file', e.target.files[0]);

      try {
        const response = await uploadImage(formData);
        setImageUrl(response.data.url);
        toast.success('Banner image uploaded successfully!');
      } catch (error) {
        console.error('Error uploading image:', error);
        toast.error('Failed to upload banner image');
      } finally {
        setIsUploading(false);
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!imageUrl) {
      toast.error('Please upload a banner image');
      return;
    }

    if (!altText.trim()) {
      toast.error('Please enter alt text for the banner image');
      return;
    }

    try {
      await addBanner({
        countryId: countryId,
        bannerImages: [imageUrl],
        bannerImagesWeb:[{
          bannerImage:imageUrl,
          bannerImageAltText:altText
        }],
        
      });
      
      toast.success('Banner added successfully');
      getFaqs();
      handleClose();
      setImageUrl('');
      setAltText('');
    } catch (error) {
      console.error('Error adding banner:', error);
      toast.error('Failed to add banner');
    }
  };

  const closePopup = () => {
    handleClose();
    setImageUrl('');
    setAltText('');
  };

  return (
    <Modal size="xl" show={show} onHide={handleClose}>
      <Modal.Header className={styles.modHead}>
        <Modal.Title>Add Banner</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.faqContent}>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="w-100 mb-1">
              Upload Banner Image
            </label>
            <input
              className={styles.input}
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              disabled={isUploading}
              required
            />
            {isUploading && (
              <div className="mt-2">
                <small className="text-info">Uploading image...</small>
              </div>
            )}
            {imageUrl && (
              <div className="mt-3">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <label className="mb-0">Image Preview:</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => setImageUrl('')}
                  >
                    Remove Image
                  </button>
                </div>
                <div className="border rounded p-2" style={{ maxWidth: '400px' }}>
                  <img
                    src={imageUrl}
                    alt={altText || "Uploaded preview"}
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: '200px',
                      objectFit: 'cover',
                      borderRadius: '4px'
                    }}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="mb-3">
            <label className="w-100 mb-1">
              Banner Image Alt Text
              <span className="text-danger">*</span>
            </label>
            <input
              className={styles.input}
              type="text"
              value={altText}
              onChange={(e) => setAltText(e.target.value)}
              placeholder="Enter descriptive text for the banner image"
              required
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className={styles.modFoter}>
        <button type="button" className={styles.close} onClick={closePopup}>Close</button>
        <button 
          type="button" 
          className={styles.button} 
          onClick={handleSubmit}
          disabled={isUploading || !imageUrl || !altText.trim()}
        >
          Save Changes
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateUpdateBanner; 